<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelDown">엑셀</el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelDown2">엑셀 II</el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="14">
              <el-form-item label-width="0px">
                <el-row>
                  <el-col :span="24">
                    <el-col :span="5">
                      <el-select v-model="form.dtType">
                        <el-option value='' label="전체">전체</el-option>
                        <el-option
                            v-for="item in combos['dtType']"
                            :key="item.value"
                            :value="item.key"
                            :label="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="9">
                      <el-date-picker type="date" placeholder="Pick a date" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                    <el-col :span="1" style="text-align: start;">-</el-col>
                    <el-col :span="9">
                      <el-date-picker type="date" placeholder="Pick a date" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="처리결과/미처리사유" label-width="135px">
                <el-col :span="16">
                  <el-select v-model="form.asStatus">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['asStatus']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="6">
              <el-form-item label="처리유형" label-width="100px">
                <el-select v-model="form.changeAsClassCd">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['changeAsClassCd']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="접수유형" label-width="100px">
                <el-select v-model="form.asClass">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['asClass']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="지역/센터" label-width="100px">
                <el-col :span="8">
                  <el-select v-model="form.catId" @change="onCatIdChange">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="(item, idx) in combos['catId']"
                        :key="idx"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <el-select v-model="form.subCatId" v-if="changeCatIdShow">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                      v-for="(item, idx) in combos['subCatId']"
                      :key="idx"
                      :value="item.key"
                      :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="6">
              <el-form-item label="방번호" label-width="100px">
                <el-input type="text" v-model="form.pointCenter" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="고객구분" label-width="100px">
                <el-select v-model="form.custType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['custType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$i18n.messages[$store.state.locale].siteNm" label-width="100px">
                <el-row>
                  <el-col :span="8">
                    <el-input type="text" v-model="form.siteNm1" @keyup.native.enter="goOpen"></el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input type="text" v-model="form.siteNm2" @keyup.native.enter="goOpen"></el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input type="text" v-model="form.siteNm3" @keyup.native.enter="goOpen"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                :enableRangeSelection="true"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClicked" />
          </div>

          <div class="grid-tbl-box" v-show="false">
            <ag-grid-vue
                ref="excelGrid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="excelColumnDefs"
                :grid-options="excelGridOptions"
                :row-data="excelData"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                @grid-ready="onReadyExcel"
            />
          </div>
          <div class="grid-tbl-box" v-show="false">
            <ag-grid-vue
                ref="excelGrid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="excelColumnDefs2"
                :grid-options="excelGridOptions"
                :row-data="excelData2"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                @grid-ready="onReadyExcel2"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ReceptionModal from "@/components/AS/CallDispose/Modal/ReceptionModal";

import mixin from "@/mixin/lucoms";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}
function _phone(hp){
  return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}
function comma(val){
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default {
  props: {
  },
  mixins: [mixin],
  data() {
    return {
      data: [],
      excelData: [],
      excelData2: [],
      form: {
        companyId : '',
        startDt: this.$moment().add(-1, 'month').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        dtType: 'Result',          // 장애접수처리리스트기간타입
        asStatus : 'Complete',     // AS진행상태(처리결과/미처리사유)
        changeAsClassCd : '',      // AS처리유형
        asClass : '',              // AS접수유형
        catId : '',                // 지역/센터
        subCatId: '',              // 지역 상세
        custType : '',             // 고객구분
        siteNm1 : '',              // 사이트명1
        siteNm2 : '',              // 사이트명2
        siteNm3 : '',              // 사이트명3
        sortType :  '',
        processTime : ''
      },
      combos: {
        'dtType': [],
        'asStatus' : [],
        'changeAsClassCd' : [],
        'asClass' : [],
        'catId' : [],
        'custType' : [],
        'catId' : [],
        'subCatId' :[]
      },
      startDt: this.$moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD'),
      endDt: this.$moment().format('YYYY-MM-DD'),
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 20px; width: 100%;height: 700px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      excelGridApi: null,
      excelColumnApi: null,
      excelGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
        excelStyles: [
          {
            id: 'numberType',
            numberFormat: {
              format: '0',
            },
          },
          {
            id: 'stringType',
            dataType: 'String',
          },
          {
            id: 'dateType',
            dataType: 'DateTime',
          },
        ],
      },
      columnDefs: [],
      excelColumnDefs: [],
      excelColumnDefs2: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      changeCatIdShow : false,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    onReadyExcel() {
      this.excelGridApi = this.excelGridOptions.api;
      this.excelColumnApi = this.excelGridOptions.columnApi;
    },
    onReadyExcel2() {
      this.excelGridApi = this.excelGridOptions.api;
      this.excelColumnApi = this.excelGridOptions.columnApi;
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'접수일자', field:'callDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'접수번호', field:'asId', width:150, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
          }
        },
        {headerName:'고객구분', field:'custType', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'사이트명', field:'siteNm', width:160},
        {headerName:'신고자명', field:'boundCustNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'접수유형', field:'asClassNm2', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'처리일자', field:'procDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'처리유형', field:'changeAsClassNm2', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'고장증상', field:'asRepairCatNm4', width:180},
        {headerName:'미처리사유', field:'changePayYnNm9', width:130},
        {headerName:'처리센터', field:'repairAsAgentNm', width:110, cellStyle:{textAlign: 'center'}},
      ];
    },
    createExcelColumnDefs() {
      const that = this;
      this.excelColumnDefs = [
        {headerName:'고객명', field:'custNm', cellStyle:{textAlign: 'center'}, width:120},
        {headerName:'신고자명', field:'boundCustNm', width:180},
        {headerName:'고객구분', field:'custType', width:200},
        {headerName:'사이트명', field:'siteNm', width:260},
        {headerName:'MA구분', field:'maYn', width:220},
        {headerName:'전화번호', field:'telNo', width:140, cellStyle:{textAlign: 'center'}},
        {headerName:'휴대폰번호', field:'hpNo', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'주소', field:'addr1', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'고객 요구사항', field:'callMemo', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'제조사', field:'makerNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수일시', field:'callDt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수번호', field:'asId', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수센터', field:'createAsAgentNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수자', field:'asCreatorNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'제품군', field:'modelGroupNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'대표모델', field:'standardModelNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'모델', field:'modelNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수유형', field:'asClassNm2', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수세부유형', field:'asClassNm3', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수고장증상구분', field:'asCatNm3', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수고장증상', field:'asCatNm4', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'상세증상', field:'asCatDescription', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수(유/무상)', field:'payYn', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'배정일시', field:'allocationDt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'약속일시', field:'requestVisitDt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'제조번호', field:'serialNo', width:160, cellStyle:{textAlign: 'right'}, cellClass: 'stringType'},
        {headerName:'제조년월', field:'prodDt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'구입년월', field:'purchaseDt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'처리센터', field:'repairAsAgentNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'처리유형', field:'changeAsClassNm2', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'유무상변경사유', field:'changePayYnNm3', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'처리유형변경사유(상세)', field:'changeAsClassMemo', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'처리(유/무상)', field:'changePayYn', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'수리비', field:'asRepairAmt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'자재비', field:'asRepairItemAmt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'청구금액', field:'asRepairFeeAmt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'실청구금액', field:'asRepairFeeAmtReal', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'고장원인구분', field:'asFailureCauseNm2', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'고장원인명', field:'asFailureCauseNm3', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'고장상세원인명', field:'asFailureDescription', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'수리내역(증상구분)', field:'asRepairCatNm3', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'수리내역(고장증상)', field:'asRepairCatNm4', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'수리내역(고장부위)', field:'asRepairCatNm5', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'수리내역(상세수리내역)', field:'asRepairDescription', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'사용자재', field:'asRepairItemItemCd', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'사용수량', field:'asRepairItemItemQty', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'회수자재', field:'asRepairItemRecallItemCd2', width:160, cellStyle:{textAlign: 'right'}, cellClass: 'stringType'},
        {headerName:'회수수량', field:'asRepairItemRecallItemQty1', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'교환모델', field:'changeModelNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'교환모델제조번호', field:'changeSerialNo', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'교환모델제조년월', field:'changeProdDt', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'미처리사유', field:'changePayYnNm9', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'미처리사유상세', field:'asStatusMemo', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'특기사항', field:'description', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'처리자', field:'repairNm', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'요청일시', field:'requestVisitDt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'처리일시', field:'procDt', width:160, cellStyle:{textAlign: 'right'}},
      ];
    },
    createExcelColumnDefs2() {
      const that = this;
      this.excelColumnDefs2 = [
        {headerName:'고객명', field:'custNm', cellStyle:{textAlign: 'center'}, width:120},
        {headerName:'신고자명', field:'boundCustNm', width:180},
        {headerName:'고객구분', field:'custType', width:200},
        {headerName:'사이트명', field:'siteNm', width:260},
        {headerName:'MA구분', field:'maYn', width:220},
        {headerName:'전화번호', field:'telNo', width:140, cellStyle:{textAlign: 'center'}},
        {headerName:'휴대폰번호', field:'hpNo', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'주소', field:'addr1', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'고객 요구사항', field:'callMemo', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'제조사', field:'makerNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수일시', field:'callDt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수번호', field:'asId', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수센터', field:'createAsAgentNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수자', field:'asCreatorNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'제품군', field:'modelGroupNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'대표모델', field:'standardModelNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'모델', field:'modelNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수유형', field:'asClassNm2', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수세부유형', field:'asClassNm3', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수고장증상구분', field:'asCatNm3', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수고장증상', field:'asCatNm4', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'상세증상', field:'asCatDescription', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'접수(유/무상)', field:'payYn', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'배정일시', field:'allocationDt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'약속일시', field:'requestVisitDt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'제조번호', field:'serialNo', width:160, cellStyle:{textAlign: 'right'}, cellClass: 'stringType'},
        {headerName:'제조년월', field:'prodDt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'구입년월', field:'purchaseDt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'처리센터', field:'repairAsAgentNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'처리유형', field:'changeAsClassNm2', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'유무상변경사유', field:'changePayYnNm3', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'처리유형변경사유(상세)', field:'changeAsClassMemo', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'처리(유/무상)', field:'changePayYn', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'수리비', field:'asRepairAmt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'자재비', field:'asRepairItemAmt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'청구금액', field:'asRepairFeeAmt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'실청구금액', field:'asRepairFeeAmtReal', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'고장원인구분', field:'asFailureCauseNm2', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'고장원인명', field:'asFailureCauseNm3', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'고장상세원인명', field:'asFailureDescription', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'수리내역(증상구분)', field:'asRepairCatNm3', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'수리내역(고장증상)', field:'asRepairCatNm4', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'수리내역(고장부위)', field:'asRepairCatNm5', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'수리내역(상세수리내역)', field:'asRepairDescription', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'사용자재', field:'asRepairItemItemCd', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'사용수량', field:'asRepairItemItemQty', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'회수자재', field:'asRepairItemRecallItemCd2', width:160, cellStyle:{textAlign: 'right'}, cellClass: 'stringType'},
        {headerName:'회수수량', field:'asRepairItemRecallItemQty1', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'교환모델', field:'changeModelNm', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'교환모델제조번호', field:'changeSerialNo', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'교환모델제조년월', field:'changeProdDt', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'미처리사유', field:'changePayYnNm9', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'미처리사유상세', field:'asStatusMemo', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'특기사항', field:'description', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'처리자', field:'repairNm', width:160, cellStyle:{textAlign: 'right'}},

        {headerName:'요청일시', field:'requestVisitDt', width:160, cellStyle:{textAlign: 'right'}},
        {headerName:'처리일시', field:'procDt', width:160, cellStyle:{textAlign: 'right'}},
      ];
    },
    onCellClicked(params) {
      //const idx = params.rowIndex;
      const field = params.colDef.field;
      if(field === 'asId') {
        this.openModel(params.data);
      }
    },
    /**
     * 접수/처리 상세 팝업 오픈
     */
    openModel(param) {
      console.log(param);
      let vm = this;
      this.$modal.open({
        width: 800,
        component: ReceptionModal,
        parent: this,
        props: {
          data: {
            asId: param.asId,
            custId: param.custId,
            sortType: '',
            popHeadInfo: {}, //this.custParam.popHeadInfo,
            //reqDt: this.$moment('20230101').format('YYYY-MM-DD'),
            recptDt: this.$moment(param.callDt).format('YYYY-MM-DD'),
            procsDt: this.$moment(param.procDt).format('YYYY-MM-DD'),
            menuGubun : 'CallDisposeList'
          }
        },
        events: {
          close(data) {
            console.log('close', data);
          },
        }
      });
    },
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    goOpen() {
      this.$store.commit('loading')

      const vForm = {
        companyId :this.form.companyId,
        startDt: this.form.startDt || '2000-01-01',
        endDt: this.form.endDt || '2100-12-31',
        dtType: this.form.dtType,
        asStatus : this.form.asStatus,
        changeAsClassCd : this.form.changeAsClassCd,
        asClass : this.form.asClass,
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId, // 지역
        subCatId: this.form.subCatId, // 지역 상세
        custType : this.form.custType,
        siteNm1: this.form.siteNm1 ? this.form.siteNm1 : '',
        siteNm2: this.form.siteNm2 ? this.form.siteNm2 : '',
        siteNm3: this.form.siteNm3 ? this.form.siteNm3 : '',
        sortType : this.form.sortType,
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }
      this.$http.post(_url("/api/workMng/callDispose/list"), vForm).then(response => {
        this.data = response.data
        /* data customize */
        this.changeData();
      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    /* data customize */
    changeData(){
      this.data.map((x, i) => {
        let filterCustType = this.combos['custType'].filter(y => y.key === x.custType);
        x.custType = filterCustType[0].value;
      })
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/callDispose/init`)
          .then(response => {
            this.combos['dtType'] = response.data.dtType;
            this.combos['asStatus'] = response.data.asStatus;
            this.combos['changeAsClassCd'] = response.data.changeAsClassCd;
            this.combos['asClass'] = response.data.asClass;
            this.combos['catId'] = response.data.catId;
            this.combos['custType'] = response.data.custType;
          }).finally(() => {
            this.goOpen();
            this.$store.commit('finish');
          });

      this.createMainColumnDefs();
      this.createExcelColumnDefs();
      this.createExcelColumnDefs2();
    },
    onCatIdChange(param){
      if(param === '') {
        this.changeCatIdShow =  false;
      }
      else{
        this.changeCatIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
          .then(async (response) => {
            this.combos['subCatId'] =  response.data || [{key: '', value: '전체'}]
          })
          .finally(_ => {
            this.form.subCatId = '';
          });
      }
    },
    excelDown() {
      const vForm = {
        companyId: this.form.companyId,
        dtType: this.form.dtType,
        startDt: this.form.startDt,
        endDt: this.form.endDt,
        asClass: this.form.asClass,
        changeAsClassCd: this.form.changeAsClassCd,
        asStatus: this.form.asStatus,
        custType: this.form.custType,
        siteNm1: this.form.siteNm1,
        siteNm2: this.form.siteNm2,
        siteNm3: this.form.siteNm3,
        catId: (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,
        sortType: this.form.sortType,
        processTime: ''
      }

      this.$store.commit('loading')
      this.$http.post('/api/workMng/callDispose/list', vForm, {timeout: 60000*20})
          .then(response => {
            this.excelData = response.data.map(x => {
              let filterCustType = this.combos['custType'].filter(y => y.key === x.custType);
              x.custType = filterCustType[0]?.value;
              x.telNo = _phone(x.telNo) || '';
              x.hpNo = _phone(x.hpNo) || '';
              x.addr1 = x.addr1 !== null ? x.addr1 + ' ' + x.addr2 : ''
              x.callDt = x.callDt !== null ? this.$moment(x.callDt).format('YYYY-MM-DD HH:mm:ss') : ''
              x.payYn = x.payYn === 'Y' ? '유' : '무'
              x.allocationDt = x.allocationDt !== null ? this.$moment(x.allocationDt).format('YYYY-MM-DD HH:mm:ss') : ''
              x.requestVisitDt = x.requestVisitDt !== null ? this.$moment(x.requestVisitDt).format('YYYY-MM-DD HH:mm:ss') : ''
              x.prodDt = x.prodDt !== null ? this.$moment(x.prodDt).format('YYYY-MM-DD') : ''
              x.purchaseDt = x.purchaseDt !== null ? this.$moment(x.purchaseDt).format('YYYY-MM-DD') : ''
              x.changePayYn = x.changePayYn === 'Y' ? '유' : '무'
              x.asRepairItemRecallItemQty1 = (x.asRepairItemRecallItemQty1 + x.asRepairItemRecallItemQty2)
              x.changeProdDt = x.changeProdDt !== null ? this.$moment(x.changeProdDt).format('YYYY-MM-DD') : ''
              x.procDt = this.$moment(x.procDt).format('YYYY-MM-DD HH:mm:ss')
              x.asRepairAmt = comma(x.asRepairAmt) || ''
              x.asRepairItemAmt = comma(x.asRepairItemAmt) || ''
              x.asRepairFeeAmt = comma(x.asRepairFeeAmt) || ''
              x.asRepairFeeAmtReal = comma(x.asRepairFeeAmtReal) || ''

              return x;
            })
          }).finally(() => {
            this.$store.commit('finish');
            var params = { fileName: "AS처리리스트" };
            this.excelGridOptions.api.exportDataAsExcel(params);
      })
    },
    excelDown2() {
      const vForm = {
        companyId: this.form.companyId,
        dtType: this.form.dtType,
        startDt: this.form.startDt,
        endDt: this.form.endDt,
        asClass: this.form.asClass,
        changeAsClassCd: this.form.changeAsClassCd,
        asStatus: this.form.asStatus,
        custType: this.form.custType,
        siteNm1: this.form.siteNm1,
        siteNm2: this.form.siteNm2,
        siteNm3: this.form.siteNm3,
        catId: (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,
        sortType: this.form.sortType,
        processTime: ''
      }

      this.$store.commit('loading')
      
      this.$http.post('/api/workMng/callDispose/list/excel2', vForm, {timeout: 60000*20} )
          .then(response => {
            this.excelData2 = response.data.map(x => {
              let filterCustType = this.combos['custType'].filter(y => y.key === x.custType);
              x.custType = filterCustType[0]?.value;
              x.telNo = _phone(x.telNo) || '';
              x.hpNo = _phone(x.hpNo) || '';
              x.addr1 = x.addr1 !== null ? x.addr1 + ' ' + x.addr2 : ''
              x.callDt = x.callDt !== null ? this.$moment(x.callDt).format('YYYY-MM-DD HH:mm:ss') : ''
              x.payYn = x.payYn === 'Y' ? '유' : '무'
              x.allocationDt = x.allocationDt !== null ? this.$moment(x.allocationDt).format('YYYY-MM-DD HH:mm:ss') : ''
              x.requestVisitDt = x.requestVisitDt !== null ? this.$moment(x.requestVisitDt).format('YYYY-MM-DD HH:mm:ss') : ''
              x.prodDt = x.prodDt !== null ? this.$moment(x.prodDt).format('YYYY-MM-DD') : ''
              x.purchaseDt = x.purchaseDt !== null ? this.$moment(x.purchaseDt).format('YYYY-MM-DD') : ''
              x.changePayYn = x.changePayYn === 'Y' ? '유' : '무'
              x.asRepairItemRecallItemQty1 = (x.asRepairItemRecallItemQty1 + x.asRepairItemRecallItemQty2)
              x.changeProdDt = x.changeProdDt !== null ? this.$moment(x.changeProdDt).format('YYYY-MM-DD') : ''
              x.procDt = this.$moment(x.procDt).format('YYYY-MM-DD HH:mm:ss')
              x.asRepairAmt = comma(x.asRepairAmt) || ''
              x.asRepairItemAmt = comma(x.asRepairItemAmt) || ''
              x.asRepairFeeAmt = comma(x.asRepairFeeAmt) || ''
              x.asRepairFeeAmtReal = comma(x.asRepairFeeAmtReal) || ''

              return x;
            })
          }).finally(() => {
        this.$store.commit('finish');
        var params = { fileName: "AS처리리스트" };
        this.excelGridOptions.api.exportDataAsExcel(params);
      })
    }
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    console.log('search', this.search);
    this.form.companyId = this.$store.state.loginInfo.compCd;

  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>